import React from 'react';
import ReactDOM from 'react-dom/client';
import { init } from '@utils/sentry';
import App from './App';

init();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
